import React, {useCallback} from 'react';
import {useCategory} from '../../../../../data/hooks/categories';
import {uniqBy} from 'lodash';
import Solutions from './Solutions/Solutions';
import {useDispatch} from 'react-redux';
import {removeInvalidField, replaceInvalidField} from '../../../../../data/actions/requiredUserActions';

function CategoryInvalidFields(props) {
    const {categoryId, invalidFields} = props,
        category = useCategory(categoryId),
        uniqFields = uniqBy(invalidFields, invf => invf.subCondition.field),
        dispatch = useDispatch();

    console.log('DEBUG', uniqFields);

    const handleRemoveSubCondition = useCallback(
            field => {
                dispatch(removeInvalidField(categoryId, field));
            },
            [categoryId]
        ),
        handleReplaceField = useCallback(
            (oldField, newField) => {
                dispatch(
                    replaceInvalidField(
                        categoryId,
                        oldField,
                        newField,
                        invalidFields.filter(invf => invf.subCondition.field == oldField)
                    )
                );
            },
            [categoryId]
        );

    return (
        <>
            {uniqFields.map((invf, i) => (
                <tr key={i}>
                    {i == 0 ? <td rowSpan={uniqFields.length}>{category.label ?? category.id}</td> : null}
                    <td>{invf.subCondition.field}</td>
                    <td>
                        <Solutions
                            fields={category.fields}
                            onRemove={() => handleRemoveSubCondition(invf.subCondition.field)}
                            onReplace={newField => handleReplaceField(invf.subCondition.field, newField)}
                        />
                    </td>
                </tr>
            ))}
        </>
    );
}

export default CategoryInvalidFields;
